import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-column" }
const _hoisted_2 = { class: "table-header p-d-flex p-ai-center" }
const _hoisted_3 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-col-12 kn-flex-0" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.customView.title')), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          id: "document-execution-schedulations-close-button",
          class: "kn-button kn-button--primary",
          onClick: _ctx.close
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_DataTable, {
      value: _ctx.customViews,
      id: "olap-custom-views-table",
      class: "p-datatable-sm kn-table",
      dataKey: "id",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters = $event)),
      globalFilterFields: _ctx.olapCustomViewTableDescriptor.globalFilterFields,
      paginator: _ctx.customViews.length > 20,
      rows: 20,
      loading: _ctx.loading,
      responsiveLayout: "stack",
      breakpoint: "600px"
    }, {
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
      ]),
      header: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_InputText, {
              class: "kn-material-input",
              modelValue: _ctx.filters['global'].value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
              placeholder: _ctx.$t('common.search')
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.olapCustomViewTableDescriptor.columns, (column, index) => {
          return (_openBlock(), _createBlock(_component_Column, {
            class: "kn-truncated",
            key: index,
            field: column.field,
            header: _ctx.$t(column.label),
            sortable: true
          }, null, 8, ["field", "header"]))
        }), 128)),
        _createVNode(_component_Column, {
          style: _ctx.olapCustomViewTableDescriptor.iconColumn.style
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode(_component_Button, {
              icon: "pi pi-file",
              class: "p-button-link",
              onClick: ($event: any) => (_ctx.applyCustomView(slotProps.data))
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('common.apply'),
                void 0,
                { top: true }
              ]
            ]),
            _withDirectives(_createVNode(_component_Button, {
              icon: "pi pi-trash",
              class: "p-button-link",
              onClick: ($event: any) => (_ctx.deleteCustomViewsConfirm(slotProps.data))
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('common.delete'),
                void 0,
                { top: true }
              ]
            ])
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _: 1
    }, 8, ["value", "filters", "globalFilterFields", "paginator", "loading"])
  ]))
}